<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="goUserProfilePage()">
        <ion-icon class="back-icon" color="dark" name="chevron-back"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title>
      <app-offline-indicator></app-offline-indicator>
      {{ 'TRANSACTION.lbl.user' | translate }}
    </ion-title>
  </ion-toolbar>
  <ion-toolbar>
    <div class="content-div ion-padding-horizontal">
      <ion-segment scrollable [(ngModel)]="transactionType" (ionChange)="setupTransactionList()">
        <ion-segment-button value="account">
          <ion-label>{{ 'PRODUCT.account.title' | translate }}</ion-label>
        </ion-segment-button>
        <ion-segment-button value="blast">
          <ion-label>{{ 'MENU.blast' | translate }}</ion-label>
        </ion-segment-button>
      </ion-segment>
    </div>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding-horizontal" color="light" [scrollY]="false">
  <div class="content-div">
    <div class="full-width-height viewport-div" *ngIf="transactionList?.length">
      <cdk-virtual-scroll-viewport [itemSize]="itemHeight" class="ion-content-scroll-host">
        <ion-list class="full-width-height background-transparent ion-padding-bottom" lines="none" #list *ngIf="transactionList?.length">
          <div class="card-margin" *cdkVirtualFor="let transaction of transactionList; trackBy: trackByFn;" [style.height.px]="itemHeight(transaction)">
            <ion-item class="item-card item full-width" [style.--min-height.px]="itemHeight(transaction)" lines="none">
              <ion-label class="ion-no-margin">
                <div>
                  <ion-icon class="font-12 icon" name="star"></ion-icon>
                  <ion-text class="font-12 ion-text-wrap">#{{ transaction?.transactionId }}</ion-text>
                </div>
                <div *ngIf="transaction?.status">
                  <ion-icon class="font-12 icon" color="medium" name="star"></ion-icon>
                  <ion-text class="font-12 ion-text-wrap" color="medium" *ngIf="transactionAmount?.[transaction.transactionId] >= 0 else refunded">{{ 'PAYMENT.status.' + transaction?.status | translate }}</ion-text>
                  <ng-template #refunded>
                    <ion-text class="font-12 font-bold ion-text-wrap" [color]="'danger'">{{ 'PAYMENT.status.refunded' | translate }}</ion-text>
                  </ng-template>
                </div>
                <div>
                  <ion-icon class="font-12 icon" color="medium" src="./assets/wedding/icon/subscription/bag.svg"></ion-icon>
                  <ion-text class="font-12 ion-text-wrap" color="medium">{{ transaction.payment.amount | currency: transaction.payment.currency: 'symbol' }}</ion-text>
                </div>
                <div>
                  <ion-icon class="font-12 icon" color="medium" name="calendar-outline"></ion-icon>
                  <ion-text class="font-12 ion-text-wrap" color="medium">{{ format(transaction?.updateBy?.time?.seconds * 1000) }}</ion-text>
                </div>
                <div>
                  <ion-icon class="font-12 icon" color="medium" src="./assets/wedding/icon/general/credit-card.svg"></ion-icon>
                  <ion-text class="font-12 ion-text-wrap" color="medium" *ngIf="transaction?.paymentRef">{{ getPaymentMethod(transaction.paymentRef) }}</ion-text>
                  <!-- {{ transaction.paymentRef.method.toUpperCase() }}
                    <ng-container *ngIf="transaction?.paymentRef?.detail?.brand && transaction?.paymentRef?.detail?.card">
                      ({{ transaction.paymentRef.detail.brand.toUpperCase() }},&nbsp;{{ transaction.paymentRef.detail.card }})
                    </ng-container>
                    <ng-container *ngIf="transaction?.paymentRef?.detail?.fpx">
                      ({{ getFpxDetail(transaction.paymentRef.detail.fpx) }})
                    </ng-container> -->
                </div>
                <div *ngIf="refundList?.[transaction?.transactionId] as refundList">
                  <ion-item class="full-width refund-item ion-item-no-padding" lines="none" *ngIf="refundList?.length">
                    <ng-container *ngFor="let refund of refundList">
                      <div *ngIf="refund?.refundId && refund?.refund?.amount && refund?.refund?.currency === transaction.payment.currency">
                        <ion-icon class="font-12 icon" color="danger" name="alert-circle-outline"></ion-icon>
                        <ion-text class="font-10 ion-text-wrap" color="danger" [innerHTML]="'REFUND.lbl.full_title' | translate: { amount: refund.refund.amount | currency: transaction.payment.currency: 'symbol', date: format(refund?.createBy?.time?.seconds * 1000) }">
                        </ion-text>
                      </div>
                    </ng-container>
                  </ion-item>
                </div>
              </ion-label>
              <ion-button class="btn" shape="round" slot="end" *ngIf="transaction?.status === 'succeeded'" (click)="presentUserReceiptModal(transaction)">
                {{ 'RECEIPT.title' | translate }}
              </ion-button>
              
            </ion-item>
            
          </div>
        </ion-list>
      </cdk-virtual-scroll-viewport>
    </div>
    
    <div class="full-width-height center vertical-center" *ngIf="!transactionList?.length">
      <ion-label class="ion-text-center ion-margin ion-padding" color="medium">
        <ion-icon class="center icon-cactus" src="./assets/wedding/icon/general/no-record.svg"></ion-icon>
        <div class="ion-margin-top font-14">{{ 'LBL.no_found' | translate }}</div>
      </ion-label>
    </div>
  </div>
  
</ion-content>
<ion-footer>
  <ion-toolbar>
    <div class="content-div">
      <ion-button class="ion-margin" expand="block" color="primary" fill="solid" type="button" (click)="purchase()">
        <ng-container *ngIf="transactionType === 'account'">
          {{ 'PRODUCT.title.purchase' | translate }}
        </ng-container>
        <ng-container *ngIf="transactionType === 'blast'">
          {{ 'BLAST.lbl.send' | translate }}
        </ng-container>
      </ion-button>
    </div>
  </ion-toolbar>
</ion-footer>